import { callApi } from 'utils/api/callApi'
import { Five9Data } from '../types'

const DETAILS_REQUEST_DATA = {
  endpoint: { url: 'https://app.five9.com/appsvcs/rs/svc/auth/metadata' }, // Tells `callApi` to use this *exact* url.
  other: {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  },
}

export const fetchFive9Data = async (): Promise<Five9Data | null> => {
  try {
    const detailsResult = await callApi(DETAILS_REQUEST_DATA)
    const details: Omit<Five9Data, 'campaignName'> = {
      orgID: detailsResult.orgId,
      userID: detailsResult.userId,
      apiURL: detailsResult.metadata.dataCenters[0].apiUrls[0].host,
    }
    const campaignIdResult = await callApi({
      ...DETAILS_REQUEST_DATA,
      endpoint: {
        url: `https://${details.apiURL}/appsvcs/rs/svc/agents/${details.userID}/campaigns_config`,
      },
    })
    const campaigns = (await callApi({
      ...DETAILS_REQUEST_DATA,
      endpoint: { url: `https://${details.apiURL}/appsvcs/rs/svc/orgs/${details.orgID}/campaigns` },
    })) as any[]

    const campaignId = campaignIdResult.campaignIds?.[0] ?? campaignIdResult.defaultCampaignId

    const campaignName = campaigns.find(
      camp => camp.campaignType === 'OUTBOUND' && camp.id === campaignId
    )

    if (!campaignName) {
      return null
    }

    return {
      ...details,
      campaignName,
    }
  } catch (error) {
    return null
  }
}
